import React, { useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@mui/styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    sx: {
        zIndex: 10001,
    },
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 170,
        },
    },
};

const useStyles = makeStyles(() => ({
    root: {
        "& svg": {
            left: "unset",
        },
    },
}));

export default function MultipleSelect(props) {
    const { options, label, name, onChange, selectedKeys, disabled } = props;
    const classes = useStyles();

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        onChange(
            // On autofill we get a stringified value.
            typeof value === "string" ? value : value.join(","),
            name,
        );
    };

    return (
        <div>
            <FormControl sx={{ m: 1, width: 170 }}>
                {label && (
                    <InputLabel id="demo-multiple-checkbox-label">
                        {label}
                    </InputLabel>
                )}
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectedKeys}
                    onChange={handleChange}
                    renderValue={(selected) =>
                        selected.map((k) => options[k]).join(", ")
                    }
                    MenuProps={MenuProps}
                    classes={{ root: classes.root }}
                    name={name}
                    // disabled={disabled}
                >
                    {Object.keys(options).map((key) => (
                        <MenuItem key={key} value={key}>
                            <Checkbox
                                checked={selectedKeys.indexOf(key) > -1}
                            />
                            <ListItemText primary={options[key]} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
